export const RESET_MEMORY_EVENT = 'RESET_MEMORY';

export const resetMemoryEventEmitter = new EventTarget();
